module.exports = __webpack_public_path__ + "static/img/album01_2.74d760e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album01/album01_2.png
// module id = WkFa
// module chunks = 1